<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles({...element.compData.styles, wrapHeight: element.boxStyle.height}),
    width: element.width + 'px',
    height: element.height + 'px'}">
    <div class="navigation">
      <div :class="['navbar', {'flex-space': !element.compData.menus[0].width || element.compData.menus[0].width * 1 === 1 }]" v-if="element.compData.navStyle === 'transverse'">
        <div v-for="(item, index) in element.compData.menus"
          :class="['nav-item', {'active': element.compData.activeEnable && element.compData.activeIndex === index, 'activeShodow': element.compData.showShadow && element.compData.activeIndex === index}]" :key="index"
          @click="navItemClick($event,index)"
          :style="`margin-right:${element.compData.menus[index].width}px`"
        >
          <div class="nav-title nav-title-top" v-if="element.compData.iconPosition ==='top'">{{ item.name }}</div>
          <img :class="['icon-default', ( !element.compData.activeEnable ? true : element.compData.activeIndex !== index )  ? 'default-img': '' , {'nav-center': element.compData.iconPosition === 'center'}]" v-if="element.compData.disable" :src="(element.compData.activeEnable && element.compData.activeIndex === index) ? (isAbsoluteUrl(item.activeIcon) ? item.activeIcon: handleRepairePublicPrefix(item.activeIcon)) : isAbsoluteUrl(item.icon) ? item.icon: handleRepairePublicPrefix(item.icon)">
          <img :class="['icon-hover', {'nav-center':element.compData.iconPosition === 'center'}]"  v-if="element.compData.disable && (!element.compData.activeEnable || element.compData.activeIndex !== index)" :src="(item.hoverIcon && item.hoverIcon !== '') ? (isAbsoluteUrl(item.hoverIcon) ? item.hoverIcon: handleRepairePublicPrefix(item.hoverIcon)) : isAbsoluteUrl(item.icon) ? item.icon: handleRepairePublicPrefix(item.icon)">
          <div class="nav-title nav-title-center" v-if="element.compData.iconPosition ==='center'">{{ item.name }}</div>
          <div class="nav-title nav-title-bottom" v-if="element.compData.iconPosition=='bottom'">{{ item.name }}</div>
        </div>
      </div>
      <div :class="['navbar navbar-vertical', {'flex-space': !element.compData.menus[0].width || element.compData.menus[0].width * 1 === 1}]" v-else>
        <div v-for="(item, index) in element.compData.menus"
          :class="['nav-item nav-item-vertical', {'active': element.compData.activeEnable && element.compData.activeIndex === index, 'activeShodow': element.compData.showShadow && element.compData.activeIndex === index}]" :key="index"
          @click="navItemClick($event,index)"
          :style="`margin-bottom:${element.compData.menus[index].width}px`"
        >
          <div class="nav-title-v nav-title-left" v-if="element.compData.verticalIconPosition ==='left'">{{ item.name }}</div>
          <img :class="['icon-default', ( !element.compData.activeEnable ? true : element.compData.activeIndex !== index ) ? 'default-img': '' , {'nav-center': element.compData.verticalIconPosition === 'center'}]" v-if="element.compData.disable" :src="(element.compData.activeEnable && element.compData.activeIndex === index) ? (isAbsoluteUrl(item.activeIcon) ? item.activeIcon: handleRepairePublicPrefix(item.activeIcon)) : isAbsoluteUrl(item.icon) ? item.icon: handleRepairePublicPrefix(item.icon)">
          <img :class="['icon-hover', {'nav-center':element.compData.verticalIconPosition === 'center'}]"  v-if="element.compData.disable && (!element.compData.activeEnable || element.compData.activeIndex !== index)" :src="(item.hoverIcon && item.hoverIcon !== '') ? (isAbsoluteUrl(item.hoverIcon) ? item.hoverIcon: handleRepairePublicPrefix(item.hoverIcon)) : isAbsoluteUrl(item.icon) ? item.icon: handleRepairePublicPrefix(item.icon)">
          <div class="nav-title-v nav-title-center" v-if="element.compData.verticalIconPosition ==='center'">{{ item.name }}</div>
          <div class="nav-title-v nav-title-right" v-if="element.compData.verticalIconPosition=='right'">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table } from 'view-design'
import 'view-design/dist/styles/iview.css'
import { handleRepairePublicPrefix } from '@/util'
export default {
  name: 'CompTable',
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {
    Table
  },
  data: () => {
    return {
      loading: true,
      handleRepairePublicPrefix
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  mounted () {
    this.element.compData.activeIndex = this.element.compData.defaultActiveIndex
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: this.element.compData.menus[this.element.compData.activeIndex],
        data: this.plugin,
        event: null
      }
    })
  },
  methods: {
    navItemClick(ev,index) {
      ev.stopPropagation()
      this.element.compData.activeIndex = index
      // this.element.compData.defaultActiveIndex = index
      this.element.compData.activeEnable = true
      let menuItem = this.element.compData.menus[index]
      menuItem && this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.plugin.id,
        dataKey: 'onclick',
        eventData: {
          value: menuItem,
          data: this.plugin,
          event: null
        }
      })
    },
    isAbsoluteUrl(url){
      return /^[a-z][a-z0-9+.-]*:/.test(url)
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    },
    // navItemClick (index) {
    //   this.element.compData.activeIndex = index
    // }
  }
}
</script>

<style lang='less' scoped>
.wrap,.navigation {
  width: 100%;
  height: var( --wrapHeight);
}
.flex-space{
  justify-content: space-around;
}
.navbar{
  width:100%;
  height:100%;
  display: flex;
  // justify-content: space-around;
  background: var(--headBgColor);
  .nav-item{
    text-align: center;
    padding:0 10px;
    font-size:var(--headFontSize);
    color: var(--headFontColor);
    font-family: var(--fontFamily) !important;
    cursor: pointer;
    position: relative;
    .nav-title{
      font-size: var(--navFontSize);
      font-family: var(--fontFamily) !important;
    }
    .nav-title-v{
      font-size: var(--navFontSize);
      font-family: var(--fontFamily) !important;
      margin:auto;
    }
    .nav-center{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .nav-title-top{
      margin-bottom: var(--iconTitleHeight);
    }
    .nav-title-bottom{
      margin-top: var(--iconTitleHeight);
    }
    .nav-title-center{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      word-break: keep-all;
    }
    img {
      width: auto;
      height:  var(--iconHeight);
      margin-bottom: 5px;
    }
    .icon-default {
      display: block;
      margin: 0 auto;
    }
    .icon-hover {
      display: none;
    }
    &:hover{
      color: var(--hoverFontColor);
      img {
       height: var(--hoverHeight)
      }
      .default-img {
        display: none;
      }
      .icon-hover {
        display: block;
        margin:0 auto;
      }
    }
    &.active{
      color: var(--activeFontColor);
      img {
       height: var(--activeHeight)
      }
    }
    &.activeShodow{
      text-shadow: var(--shadowX) var(--shadowY) var(--shadowlength) var(--shadowColor),
    }
  }
}
.navbar-vertical{
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  .nav-item-vertical{
    display:flex;
  }
}
.cursor {
  cursor: move;
}
</style>
